import React from 'react';
import { connect } from 'react-redux';

// Global Actions
import { undoHarvestEventTimeline } from 'services/harvestEvents/actions';

// Local Styles
import './styles.scss';

interface DispatchProps {
    undoHarvestEventTimeline: Function;
}

type Props = DispatchProps;

export class EventQuickUpdateCancelButtonComponent extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { props } = this;
        props.undoHarvestEventTimeline();
    };

    render(): React.ReactElement {
        return (
            <button
                className="event-quick-update-cancel-button"
                onClick={this.handleClick}
                type="button"
            >
                UNDO
            </button>
        );
    }
}

export default connect(null, { undoHarvestEventTimeline })(
    EventQuickUpdateCancelButtonComponent
);
